import React from 'react';
import PropTypes from 'prop-types';
import { FooterButton } from '../../core/components';
import { useDispatch } from 'react-redux';
import { addWaterTowers, editWaterTowers } from './store/slice';
import { showToast } from 'Core/redux/toast/slice';

const EditWaterTowers = ({ data, onChanges, onCloseModal }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = React.useState(data || {});
  const isEditMode = Boolean(data?.id);

  const handleInputChange = (field, value) => {
    const updatedData = { ...formData, [field]: value };
    setFormData(updatedData);
    onChanges(updatedData);
  };

  const valid = () => {
    const ignoreKeys = ['changed', 'id', 'isDeleted', 'userId'];
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const onSave = () => {
    if (valid()) {
      const payload = {
        ...formData,
        userId: localStorage.getItem('UserId'),
      };
      if (isEditMode) {
        dispatch(editWaterTowers(payload));
      } else {
        dispatch(addWaterTowers(payload));
      }
      onCloseModal();
    }
  };

  const handleClose = () => {
    onCloseModal();
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Asset Number <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                name="assetNumber"
                type="text"
                className="form-control"
                value={formData?.assetNumber || ''}
                onChange={e => handleInputChange('assetNumber', e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Cell Number <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.cellNumber || ''}
                onChange={e => handleInputChange('cellNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Brand <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.brand || ''}
                onChange={e => handleInputChange('brand', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Model Number <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.modelNumber || ''}
                onChange={e => handleInputChange('modelNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Tonnage <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.tonnage || ''}
                onChange={e => handleInputChange('tonnage', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Shot Size (oz) <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.shotsize || ''}
                onChange={e => handleInputChange('shotsize', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Tie Bar Distance (Horizontal) <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.tieBarDistanceH || ''}
                onChange={e => handleInputChange('tieBarDistanceH', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Tie Bar Distance (Vertical) <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.tieBarDistanceV || ''}
                onChange={e => handleInputChange('tieBarDistanceV', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Mold Height Minimum <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.moldheightMin || ''}
                onChange={e => handleInputChange('moldheightMin', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Mold Height Maximum <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.moldheightMax || ''}
                onChange={e => handleInputChange('moldheightMax', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Serial Number <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.serialNumber || ''}
                onChange={e => handleInputChange('serialNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Number of Cores <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.numberofCores || ''}
                onChange={e => handleInputChange('numberofCores', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Number of Valve Gates <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.numberofValveGates || ''}
                onChange={e => handleInputChange('numberofValveGates', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Number of Air Blows <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              <input
                type="text"
                value={formData?.numberofAirBlows || ''}
                onChange={e => handleInputChange('numberofAirBlows', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Lane <span className="text-danger">*</span>
            </label>
            <select
              value={formData?.lane || ''}
              onChange={e => handleInputChange('lane', e.target.value)}
              className="form-control"
            >
              <option value="">Select Lane</option>
              <option value="All Lanes">All Lanes</option>
            </select>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Orientation
            </label>
            <select
              value={formData?.orientation || '0'}
              onChange={e => handleInputChange('orientation', e.target.value)}
              className="form-control"
            >
              <option value="0">Select Orientation</option>
              <option value="1">Horizontal</option>
              <option value="2">Vertical</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-lg-8"></div>
        <div className="col-12 col-lg-4">
          <FooterButton
            cancelText="Cancel"
            saveText="Save Water Towers"
            onSave={onSave}
            onCancel={handleClose}
          />
        </div>
      </div>
    </div>
  );
};

EditWaterTowers.propTypes = {
  data: PropTypes.object,
  onChanges: PropTypes.func,
  onCloseModal: PropTypes.func,
};

export default EditWaterTowers;